import { motion, useReducedMotion } from 'framer-motion'

// Step 6 — the payoff: max multiplier (accent) + provably-fair reassurance. Shared.
const WinVisual = () => {
  const reduce = useReducedMotion()

  return (
    <div className="htp-win">
      <span className="htp-vlabel">Max win</span>
      <motion.div
        className="htp-maxwin"
        animate={reduce ? undefined : { scale: [1, 1.05, 1] }}
        transition={reduce ? undefined : { repeat: Infinity, duration: 2.4, ease: 'easeInOut' }}
      >
        150×
      </motion.div>
      <span className="htp-fair">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M5 13l4 4L19 7"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Provably fair — verify any round
      </span>
    </div>
  )
}

export default WinVisual
